// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const PrintIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        d="M7.76 4.67c0-.8.66-1.47 1.47-1.47h5.54c.81 0 1.47.67 1.47 1.47v1.17H7.76zm10.52 1.17h-.38V4.67c0-1.72-1.4-3.13-3.13-3.13H9.23c-1.73 0-3.13 1.4-3.13 3.13v1.17h-.37c-2.33 0-4.23 1.9-4.23 4.23v4.43c0 2.2 1.68 4 3.83 4.2.12 0 .23-.1.23-.22V16.1c0-.12-.1-.22-.22-.22h-.02c-.46 0-.82-.36-.82-.83 0-.45.36-.83.82-.83h13.36c.46 0 .83.38.83.83 0 .47-.37.83-.83.83h-.03q-.2.02-.22.22v2.38c0 .13.1.23.23.22 2.16-.2 3.84-2 3.84-4.2v-4.43c0-2.34-1.89-4.23-4.22-4.23"
        opacity=".5"
      />
      <path d="M15.74 11.17c-.46 0-.83-.36-.83-.83 0-.45.36-.83.83-.83s.83.38.83.83c0 .47-.37.83-.83.83m2.47 0c-.46 0-.84-.36-.84-.83 0-.45.37-.83.83-.83h.01c.46 0 .83.38.83.83 0 .47-.37.83-.83.83" />
      <path
        fillRule="evenodd"
        d="M8.94 22.46c-.95 0-1.73-.78-1.73-1.72V16.1c0-.12.1-.22.23-.22h9.11q.21.02.23.22v4.64c0 .94-.77 1.72-1.72 1.72zm2.13-5.18c-.46 0-.83.37-.83.83v.06c.04.43.39.77.83.77h1.86c.44 0 .8-.34.83-.77v-.06c0-.46-.37-.83-.83-.83z"
      />
    </g>
  </SvgIcon>
);

export default PrintIcon;
